<template>
  <b-button-toolbar :class="($props && $props.class) || 'ml-1 mt-1'">
    <b-btn variant="outline-primary" @click="$router.back()" class="mr-1">RETOUR</b-btn>
    <slot></slot>
  </b-button-toolbar>
</template>

<script>

export default {
  name : "back-btn-toolbar",
}
</script>

<style scoped>

</style>